import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  consultarAsegurado: ["payload"],
  consultarAseguradoLoading: null,
  consultarAseguradoSuccess: ["consultarAseguradoData"],
  consultarAseguradoFailure: ["consultarAseguradoError"],

  limpiarDatosAsegurado: ["payload"],
  limpiarDatosAseguradoLoading: null,
});

export { Types };

export default Creators;